import React, { useEffect, useRef } from 'react';

import { KATANA_PERPS } from 'config/constants';

import { metaTagsDefaults } from './metaTagsDefaults';

const {
  mainTitle,
  description: defaultDescription,
  emptyTitle,
} = metaTagsDefaults;

type Props = {
  title: string;
  shareTitle?: string;
  description?: string;
  mainKeywords?: string[];
};

/**
 * Meta tags included dynamically by native React API
 *  https://react.dev/reference/react-dom/components/meta
 *
 * Note: Previously we used `import { Helmet } from 'react-helmet-async';`. Also in MainLayout.tsx. Seee also "<HelmetProvider />".
 */
function MetaTags(props: Props) {
  const title = props.title ? `${props.title} | ${mainTitle}` : emptyTitle;
  const shareTitle = props.shareTitle
    ? `${props.shareTitle} | ${mainTitle}`
    : title;
  const description = props.description || defaultDescription;
  const keywords =
    (props.mainKeywords ? `${props.mainKeywords.join(', ')}, ` : '') +
    `${KATANA_PERPS}, Futures, DEX, Exchange, Ethereum, Decentralized, cryptocurrency`;

  const titleRef = useRef(title);

  // Delay title update slightly to avoid flicker on router transition
  useEffect(() => {
    const timer = setTimeout(() => {
      titleRef.current = title;
      document.title = title;
    }, 50); // Small delay to ensure final render

    return () => clearTimeout(timer);
  }, [title]);

  return (
    <>
      {/* <title>{title}</title> */}
      <meta property="og:title" content={shareTitle} />
      {/* <meta name="twitter:title" content={shareTitle} /> */}

      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      {/* <meta
        name="twitter:description"
        property="og:description"
        itemProp="description"
        content={description}
      /> */}

      <meta name="keywords" content={keywords} />
    </>
  );
}

export default MetaTags;
